import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import { EvaErrorBoundaryRoutes, EvaErrorPage } from '@engelvoelkersamericas/common-ui';

import { LoadingState } from '@components';
import { FormRouter } from '@forms';
import { ProtectedRoute } from '@components/AccessControl';
import { PREFIX_OTHER_USER_URL, PREFIX_OTHER_TEAM_URL, PROTECT_PAGES_BY_ROLES, TeamRole } from '@configs/constants';
import { TeamViewRouter } from '@pages/TeamViewRouter';
import { ViewRouter } from '@pages/ViewRouter';

// Lazy load the ProfilePage component
const ProfilePage = lazy(() => import('@pages').then((module) => ({ default: module.ProfilePage })));
// Lazy load the TeamProfilePage component
const TeamProfilePage = lazy(() => import('@pages').then((module) => ({ default: module.TeamProfilePage })));

const AppRoutes = () => {
  return (
    <EvaErrorBoundaryRoutes>
      <Route
        index
        path="/"
        element={
          <Suspense fallback={<LoadingState />}>
            <ProfilePage />
          </Suspense>
        }
      />
      <Route
        path={`/team`}
        element={
          <ProtectedRoute userRequiredRoles={[TeamRole.TEAM_MEMBER]} context="team">
            <Suspense fallback={<LoadingState />}>
              <TeamProfilePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_TEAM_URL}/:teamId`}
        element={
          <ProtectedRoute userRequiredRoles={[...PROTECT_PAGES_BY_ROLES.OtherUserProfilePage]} context="team">
            <Suspense fallback={<LoadingState />}>
              <TeamProfilePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/team/edit/*`}
        element={
          <ProtectedRoute userRequiredRoles={[TeamRole.TEAM_MEMBER]} context="team">
            <Suspense fallback={<LoadingState />}>
              <FormRouter isTeamView />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_TEAM_URL}/:teamId/edit/*`}
        element={
          <ProtectedRoute userRequiredRoles={[...PROTECT_PAGES_BY_ROLES.OtherUserProfilePage]} context="team">
            <Suspense fallback={<LoadingState />}>
              <FormRouter isTeamView />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/team/add/*`}
        element={
          <ProtectedRoute userRequiredRoles={[TeamRole.TEAM_ADMIN]} context="team">
            <Suspense fallback={<LoadingState />}>
              <FormRouter isTeamView />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_TEAM_URL}/:teamId/add/*`}
        element={
          <ProtectedRoute userRequiredRoles={[...PROTECT_PAGES_BY_ROLES.OtherUserProfilePage]} context="team">
            <Suspense fallback={<LoadingState />}>
              <FormRouter isTeamView />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/team/view/*`}
        element={
          <ProtectedRoute userRequiredRoles={[TeamRole.TEAM_MEMBER]} context="team">
            <Suspense fallback={<LoadingState />}>
              <TeamViewRouter />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_TEAM_URL}/:teamId/view/*`}
        element={
          <ProtectedRoute userRequiredRoles={[...PROTECT_PAGES_BY_ROLES.OtherUserProfilePage]} context="team">
            <Suspense fallback={<LoadingState />}>
              <TeamViewRouter />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/edit/*`}
        element={
          <Suspense fallback={<LoadingState />}>
            <FormRouter />
          </Suspense>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_USER_URL}/:userId/edit/*`}
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingState />}>
              <FormRouter />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/add/*`}
        element={
          <Suspense fallback={<LoadingState />}>
            <FormRouter />
          </Suspense>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_USER_URL}/:userId/add/*`}
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingState />}>
              <FormRouter />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path={`/view/*`}
        element={
          <Suspense fallback={<LoadingState />}>
            <ViewRouter />
          </Suspense>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_USER_URL}/:userId/view/*`}
        element={
          <Suspense fallback={<LoadingState />}>
            <ProtectedRoute>
              <ViewRouter />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route
        path={`/${PREFIX_OTHER_USER_URL}/:userId`}
        element={
          <Suspense fallback={<LoadingState />}>
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route path="*" element={<EvaErrorPage />} />
    </EvaErrorBoundaryRoutes>
  );
};

export default AppRoutes;
